// import React from "react";
// import "./Footer.css";
// import { Link } from "react-router-dom";
// import footer_logo from "../Assets/world-dominators1.png";
// import instagram_icon from "../Assets/instagram_icon.png";
// import pinterest_icon from "../Assets/pintester_icon.png";
// import whatsapp_icon from "../Assets/whatsapp_icon.png";

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-top">
//         <div className="footer-logo">
//           <img src={footer_logo} alt="Logo" />
//         </div>

//        <ul className="footer-links">
//   <li>
//     <Link to="/about" className="footer-link">About Us</Link>
//   </li>

//   <li>
//     <Link to="/contact" className="footer-link">Contact</Link>
//   </li>

//   <li>
//     <Link to="/terms-and-conditions" className="footer-link">
//       Terms & Conditions
//     </Link>
//   </li>

//   <li>
//     <Link to="/privacy-policy" className="footer-link">
//       Privacy Policy
//     </Link>
//   </li>

//   <li>
//     <Link to="/refund-policy" className="footer-link">
//       Refund Policy
//     </Link>
//   </li>
// </ul>

//         <div className="footer-social-icons">
//           <a
//             href="https://www.instagram.com/wdhmedia.tec?igsh=ZzYwbGlhNHVncGo4" // remove leading 0, add country code (234 for Nigeria)
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <img src={instagram_icon} alt="Instagram" />
//           </a>
//           <a
//             href="https://wa.me/2348130408405" // remove leading 0, add country code (234 for Nigeria)
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <img src={whatsapp_icon} alt="WhatsApp" />
//           </a>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <hr />
//         <p>© 2026 TechBase - All Rights Reserved.</p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

import footer_logo from "../Assets/world-dominators1.png";
import instagram_icon from "../Assets/instagram_icon.png";
import whatsapp_icon from "../Assets/whatsapp_icon.png";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img src={footer_logo} alt="World Dominators Hub Logo" />
          <p>World Dominators Hub</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>

          <ul className="footer-links">
            <li>
              <Link to="/about" onClick={scrollToTop}>About Us</Link>
            </li>
            <li>
              <Link to="/contact" onClick={scrollToTop}>Contact</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" onClick={scrollToTop}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" onClick={scrollToTop}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" onClick={scrollToTop}>
                Refund Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>

          <div className="footer-social-icons">
            <a
              href="https://www.instagram.com/wdhmedia.tec?igsh=ZzYwbGlhNHVncGo4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram_icon} alt="Instagram" />
            </a>

            <a
              href="https://wa.me/9146916155"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={whatsapp_icon} alt="WhatsApp" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 TechBase. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
